// import React, { useState } from "react";
// import api from "../../../../../api/axios";
// import Swal from "sweetalert2";

// const AddRoom = ({ roomTypes = [], amenities = [], fetchRooms }) => {
//   const [formData, setFormData] = useState({
//     room_number: "",
//     room_type_id: "",
//     capacity: "",
//     extra_beds: "",
//     extra_bed_charge: "",
//     room_price: "",
//     room_size: "",
//     bed_type: "",
//     bed_number: "",
//     description: "",
//     condition: "",
//     status: "vacant",
//     is_active: true,
//     amenities: [],
//   });

//   const toggleAmenity = (name) => {
//     setFormData((prev) => {
//       const exists = prev.amenities.includes(name);
//       return {
//         ...prev,
//         amenities: exists
//           ? prev.amenities.filter((a) => a !== name)
//           : [...prev.amenities, name],
//       };
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const clearForm = () => {
//     setFormData({
//       room_number: "",
//       room_type_id: "",
//       capacity: "",
//       extra_beds: "",
//       extra_bed_charge: "",
//       room_price: "",
//       room_size: "",
//       bed_type: "",
//       bed_number: "",
//       description: "",
//       condition: "",
//       status: "vacant",
//       is_active: true,
//       amenities: [],
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       // await api.post("/pms/rooms", formData);
//       console.log(formData);
//       Swal.fire("Success", "Room created successfully!", "success");
//       fetchRooms();
//       clearForm();
//       document.getElementById("close-add-room")?.click();
//     } catch (err) {
//       console.log(err);
//       Swal.fire("Error", "Failed to add room", "error");
//       console.log(err);
//     }
//   };

//   return (
//     <div className="offcanvas offcanvas-end" id="add-room">
//       <div className="offcanvas-header">
//         <h5>Add Room</h5>
//         <button className="btn-close" data-bs-dismiss="offcanvas"></button>
//         <button
//           type="button"
//           id="close-add-room"
//           data-bs-dismiss="offcanvas"
//           className="d-none"
//         ></button>
//       </div>

//       <div className="offcanvas-body">
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label className="form-label">Room Number</label>
//             <input
//               className="form-control"
//               name="room_number"
//               value={formData.room_number}
//               onChange={handleChange}
//               placeholder="Enter Room Number"
//             />
//           </div>

//           {/* ROOM TYPE */}
//           <div className="mb-3">
//             <label className="form-label">Room Type</label>
//             <select
//               className="form-select"
//               name="room_type_id"
//               value={formData.room_type_id}
//               onChange={handleChange}
//             >
//               <option value="">Select Room Type</option>
//               {roomTypes.map((type) => (
//                 <option key={type.id} value={type.id}>
//                   {type.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* PRICE / CAPACITY */}
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label">Room Price</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="room_price"
//                 value={formData.room_price}
//                 onChange={handleChange}
//                 placeholder="Enter price"
//               />
//             </div>

//             <div className="col-md-6 mb-3">
//               <label className="form-label">Capacity</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="capacity"
//                 value={formData.capacity}
//                 onChange={handleChange}
//                 placeholder="Enter capacity"
//               />
//             </div>
//           </div>

//           {/* EXTRA BEDS / CHARGE */}
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label">Extra Beds</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="extra_beds"
//                 value={formData.extra_beds}
//                 onChange={handleChange}
//                 placeholder="Extra Beds"
//               />
//             </div>

//             <div className="col-md-6 mb-3">
//               <label className="form-label">Extra Bed Charge</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="extra_bed_charge"
//                 value={formData.extra_bed_charge}
//                 onChange={handleChange}
//                 placeholder="Extra Charge"
//               />
//             </div>
//           </div>

//           {/* ROOM SIZE */}
//           <div className="mb-3">
//             <label className="form-label">Room Size</label>
//             <select
//               className="form-select"
//               name="room_size"
//               value={formData.room_size}
//               onChange={handleChange}
//             >
//               <option value="">Select Size</option>
//               <option value="single">Single</option>
//               <option value="Double">Double</option>
//               <option value="Triple">Triple</option>
//               <option value="Quad">Quad</option>
//               <option value="Queen">Queen</option>
//               <option value="King">King</option>
//               <option value="Others">Others</option>
//             </select>
//           </div>

//           {/* BED NUMBER */}
//           <div className="mb-3">
//             <label className="form-label">Bed Number</label>
//             <input
//               type="number"
//               className="form-control"
//               name="bed_number"
//               value={formData.bed_number}
//               onChange={handleChange}
//               placeholder="Enter Count"
//             />
//           </div>

//           {/* BED TYPE */}
//           <div className="mb-3">
//             <label className="form-label">Bed Type</label>
//             <select
//               className="form-select"
//               name="bed_type"
//               value={formData.bed_type}
//               onChange={handleChange}
//             >
//               <option value="">Select Bed Type</option>
//               <option value="kingbed">King Bed</option>
//               <option value="queenbed">Queen Bed</option>
//               <option value="electricbed">Electric Bed</option>
//               <option value="futonbed">Futon Bed</option>
//               <option value="mattressbed">Mattress Bed</option>
//               <option value="airbed">Air Bed</option>
//             </select>
//           </div>

//           {/* CONDITION */}
//           <div className="mb-3">
//             <label className="form-label">Reserve Condition</label>
//             <input
//               className="form-control"
//               name="condition"
//               value={formData.condition}
//               onChange={handleChange}
//               placeholder="Enter Condition"
//             />
//           </div>

//           {/* DESCRIPTION */}
//           <div className="mb-3">
//             <label className="form-label">Description</label>
//             <textarea
//               className="form-control"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Room Description"
//             />
//           </div>
//           {/* AMENITIES */}
//           <div className="mb-3">
//             <label className="form-label">Amenities</label>
//             <div className="row">
//               {amenities.map((item) => (
//                 <div key={item.id} className="col-6 mb-2">
//                   <div className="form-check">
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       checked={formData.amenities.includes(item.name)}
//                       onChange={() => toggleAmenity(item.name)}
//                     />
//                     <label className="form-check-label">{item.name}</label>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* BUTTONS */}
//           <div className="d-flex gap-2 mt-4">
//             <button
//               type="button"
//               className="btn btn-primary w-50"
//               onClick={clearForm}
//             >
//               Clear
//             </button>
//             <button type="submit" className="btn btn-dark w-50">
//               Save Room
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddRoom;

// Components/AddRoom.jsx
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../api/axios";

const ROOM_SIZES = [
  "single",
  "double",
  "triple",
  "king",
  "queen",
  "quad",
  "others",
];
const BED_TYPES = [
  "king_bed",
  "queen_bed",
  "electric_bed",
  "futon_bed",
  "mattress_bed",
  "air_bed",
];
const ROOM_STATUS = ["Vacant", "Reserved", "Occupied"];
const HOUSEKEEPING = ["clean", "dirty", "inspected", "out_of_service"];

const AddRoom = ({ open, onClose, onAdded }) => {
  const [form, setForm] = useState({
    room_type_id: "",
    room_number: "",
    capacity: "",
    extra_capability: "",
    bed_charge: "",
    room_size: "single",
    bed_number: "",
    bed_type: "king_bed",
    room_description: "",
    reserve_condition: "",
    is_active: true,
    status: "Vacant",
    housekeeping_status: "dirty",
    is_maintenance: false,
    amenity_ids: [],
  });

  const [roomTypes, setRoomTypes] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setForm((f) => ({
        ...f,
        room_type_id: "",
        room_number: "",
        capacity: "",
        extra_capability: "",
        bed_charge: "",
        room_size: "single",
        bed_number: "",
        bed_type: "king_bed",
        room_description: "",
        reserve_condition: "",
        is_active: true,
        status: "Vacant",
        housekeeping_status: "dirty",
        is_maintenance: false,
        amenity_ids: [],
      }));
      setLoading(false);
    }
  }, [open]);

  useEffect(() => {
    // fetch room types and amenities
    const load = async () => {
      try {
        const [rtRes, amRes] = await Promise.all([
          api.get("/pms/room-types"),
          api.get("/pms/amenities"),
        ]);
        setRoomTypes(rtRes.data || rtRes.data || []);
        setAmenities(amRes.data || amRes.data || []);
      } catch (err) {
        console.error("Failed to load room types/amenities:", err);
      }
    };
    if (open) load();
  }, [open]);

  const toggleAmenity = (id) => {
    setForm((prev) => {
      const exists = prev.amenity_ids.includes(id);
      return {
        ...prev,
        amenity_ids: exists
          ? prev.amenity_ids.filter((x) => x !== id)
          : [...prev.amenity_ids, id],
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // minimal validation
    if (!form.room_type_id) {
      Swal.fire({ icon: "warning", title: "Select room type" });
      return;
    }
    if (!form.room_number.trim()) {
      Swal.fire({ icon: "warning", title: "Room number required" });
      return;
    }

    try {
      setLoading(true);
      // prepare payload - do not send property_code
      const payload = {
        room_type_id: form.room_type_id,
        room_number: form.room_number,
        capacity: form.capacity,
        extra_capability: form.extra_capability,
        bed_charge: form.bed_charge,
        room_size: form.room_size,
        bed_number: form.bed_number,
        bed_type: form.bed_type,
        room_description: form.room_description,
        reserve_condition: form.reserve_condition,
        is_active: form.is_active,
        status: form.status,
        housekeeping_status: form.housekeeping_status,
        is_maintenance: form.is_maintenance,
        amenities: form.amenity_ids,
      };

      await api.post("/pms/rooms", payload);

      Swal.fire({
        icon: "success",
        title: "Room created",
        timer: 1200,
        showConfirmButton: false,
      });
      if (onAdded) await onAdded();
      onClose();
    } catch (err) {
      console.error("Create room error:", err);
      Swal.fire({
        icon: "error",
        title: "Failed to create",
        text: err.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal d-block" tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Add Room</h5>
              <button
                className="btn-close"
                onClick={() => {
                  if (onAdded) onAdded();
                  onClose();
                }}
              />
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Room Type</label>
                    <select
                      className="form-select"
                      value={form.room_type_id}
                      onChange={(e) =>
                        setForm({ ...form, room_type_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Room Type</option>
                      {roomTypes.map((rt) => (
                        <option key={rt.id} value={rt.id}>
                          {rt.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Room Number</label>
                    <input
                      className="form-control"
                      value={form.room_number}
                      onChange={(e) =>
                        setForm({ ...form, room_number: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Capacity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.capacity}
                      onChange={(e) =>
                        setForm({ ...form, capacity: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Extra Capability</label>
                    <input
                      className="form-control"
                      value={form.extra_capability}
                      onChange={(e) =>
                        setForm({ ...form, extra_capability: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Charge</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.bed_charge}
                      onChange={(e) =>
                        setForm({ ...form, bed_charge: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Room Size</label>
                    <select
                      className="form-select"
                      value={form.room_size}
                      onChange={(e) =>
                        setForm({ ...form, room_size: e.target.value })
                      }
                    >
                      {ROOM_SIZES.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Number</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.bed_number}
                      onChange={(e) =>
                        setForm({ ...form, bed_number: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Type</label>
                    <select
                      className="form-select"
                      value={form.bed_type}
                      onChange={(e) =>
                        setForm({ ...form, bed_type: e.target.value })
                      }
                    >
                      {BED_TYPES.map((b) => (
                        <option key={b} value={b}>
                          {b}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 mb-2">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      value={form.room_description}
                      onChange={(e) =>
                        setForm({ ...form, room_description: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-12 mb-2">
                    <label className="form-label">Reserve Condition</label>
                    <input
                      className="form-control"
                      value={form.reserve_condition}
                      onChange={(e) =>
                        setForm({ ...form, reserve_condition: e.target.value })
                      }
                    />
                  </div>

                  {/* <div className="col-md-4 mb-2">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      value={form.status}
                      onChange={(e) =>
                        setForm({ ...form, status: e.target.value })
                      }
                    >
                      {ROOM_STATUS.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  {/* <div className="col-md-4 mb-2">
                    <label className="form-label">Housekeeping</label>
                    <select
                      className="form-select"
                      value={form.housekeeping_status}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          housekeeping_status: e.target.value,
                        })
                      }
                    >
                      {HOUSEKEEPING.map((h) => (
                        <option key={h} value={h}>
                          {h}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  <div className="col-md-4 mb-2 d-flex align-items-center">
                    <div className="form-check me-3">
                      <input
                        id="is_active"
                        className="form-check-input"
                        type="checkbox"
                        checked={form.is_active}
                        onChange={() =>
                          setForm({ ...form, is_active: !form.is_active })
                        }
                      />
                      <label htmlFor="is_active" className="form-check-label">
                        Active
                      </label>
                    </div>
                    {/* <div className="form-check">
                      <input
                        id="is_maintenance"
                        className="form-check-input"
                        type="checkbox"
                        checked={form.is_maintenance}
                        onChange={() =>
                          setForm({
                            ...form,
                            is_maintenance: !form.is_maintenance,
                          })
                        }
                      />
                      <label
                        htmlFor="is_maintenance"
                        className="form-check-label"
                      >
                        Is Maintenance
                      </label>
                    </div> */}
                  </div>

                  <div className="col-12 mt-2">
                    <label className="form-label">Amenities</label>
                    <div className="d-flex flex-wrap gap-2">
                      {amenities.map((a) => (
                        <div key={a.id} className="form-check me-3">
                          <input
                            id={`amenity_${a.id}`}
                            className="form-check-input"
                            type="checkbox"
                            checked={form.amenity_ids.includes(a.id)}
                            onChange={() => toggleAmenity(a.id)}
                          />
                          <label
                            htmlFor={`amenity_${a.id}`}
                            className="form-check-label"
                          >
                            {a.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    // if (onAdded) onAdded();
                    onClose();
                  }}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRoom;
